import { Quote, Star } from "lucide-react";
import Image from "next/image";
import React from "react";

const TextTestimonalCard = ({ testimonal }: { testimonal: TextTestimonal }) => {
  return (
    <aside className="flex flex-col gap-8 p-8 rounded-lg w-full max-w-sm border">
      <div className="flex justify-end">
        <Quote className="h-8 w-8 text-skillsewa-secondary" />
      </div>
      <p className="w-full min-w-[20rem] max-w-sm">{testimonal.testimonal.slice(0, 100)}</p>
      <div className="flex flex-col items-center gap-4">
        <div className="flex gap-2 items-center justify-center">
          {Array(testimonal.stars)
            .fill(0)
            .map((star, index) => (
              <Star className="h-4 w-4 fill-amber-500 text-amber-500" key={index} />
            ))}
        </div>
        <div className="h-[4rem] w-[7rem]">
          <Image
            src={testimonal.image}
            alt={testimonal.name}
            height={200}
            width={200}
            className="object-contain rounded-full"
          />
        </div>
        <h3 className="uppercase mt-2 font-semibold truncate text-center">{testimonal.name}</h3>
      </div>
    </aside>
  );
};

export default TextTestimonalCard;
